import React, { useEffect, useState, useMemo } from "react";
import { Toaster, toast } from "react-hot-toast";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const API_BASE = "https://djatervoyage.com/backend_djatervoyage/gestionnaire";
const PAGE_SIZE = 10;

const STATUS_LABELS = {
  en_attente: "En attente",
  en_cours: "En cours",
  confirmée: "Confirmée",
  terminée: "Terminée",
};












// Logo de ton agence
const LOGO_URL = "https://djatervoyage.com/logo.png";

const printReservation = async (reservation) => {
  try {
    const data =
      typeof reservation.amadeus_data_reservation_confirmation === "string"
        ? JSON.parse(reservation.amadeus_data_reservation_confirmation)
        : reservation.amadeus_data_reservation_confirmation;

    if (!data?.data) {
      alert("❌ Aucune donnée de confirmation trouvée.");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");

    // === Chargement du logo ===
    const logo = await fetch(LOGO_URL)
      .then((res) => res.blob())
      .then(
        (blob) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          })
      );

    // === Entête ===
    doc.addImage(logo, "PNG", 15, 10, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.setTextColor(0, 51, 102);
    doc.text("Confirmation de Réservation", 105, 25, { align: "center" });

    doc.setDrawColor(0, 51, 102);
    doc.setLineWidth(1);
    doc.line(15, 42, 195, 42);

    // === Informations Générales ===
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    let y = 50;
    doc.setFont("helvetica", "bold");
    doc.text("Informations de la réservation", 15, y);
    y += 6;

    const info = [
      ["Référence interne", reservation.reference],
      ["Amadeus ID", data.data.id],
      ["Client", reservation.customer_email],
      ["Téléphone", reservation.customer_phone || "N/A"],
      ["Date de création", reservation.created_at],
    ];

    autoTable(doc, {
      startY: y,
      head: [["Champ", "Valeur"]],
      body: info,
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 3 },
      headStyles: { fillColor: [0, 51, 102], textColor: 255 },
      columnStyles: { 0: { fontStyle: "bold" } },
    });
    y = doc.lastAutoTable.finalY + 8;

    // === Passagers ===
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Liste des passagers", 15, y);
    y += 4;

    const travelers = data.data.travelers?.map((p, i) => [
      i + 1,
      `${p.name?.firstName || ""} ${p.name?.lastName || ""}`,
      p.gender || "-",
      p.dateOfBirth || "-",
      p.documents?.[0]?.number || "-",
      p.documents?.[0]?.nationality || "-",
    ]);

    autoTable(doc, {
      startY: y + 2,
      head: [["#", "Nom complet", "Sexe", "Naissance", "Document", "Nationalité"]],
      body: travelers || [],
      theme: "striped",
      headStyles: { fillColor: [0, 102, 204], textColor: 255 },
      styles: { fontSize: 10, cellPadding: 3 },
    });
    y = doc.lastAutoTable.finalY + 10;

    // === Détails du vol ===
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Détails du vol", 15, y);
    y += 6;

    const flightOffer = data.data.flightOffers?.[0];
    if (flightOffer) {
      flightOffer.itineraries?.forEach((it, i) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`Itinéraire ${i + 1} – Durée : ${it.duration}`, 15, y);
        y += 4;

        const segments = it.segments.map((s) => [
          `${s.departure.iataCode} (${new Date(s.departure.at).toLocaleString()})`,
          `${s.arrival.iataCode} (${new Date(s.arrival.at).toLocaleString()})`,
          `${s.carrierCode} ${s.number}`,
          `${s.aircraft.code}`,
          s.duration || "-",
        ]);

        autoTable(doc, {
          startY: y,
          head: [["Départ", "Arrivée", "Compagnie", "Avion", "Durée"]],
          body: segments,
          theme: "grid",
          styles: { fontSize: 9, cellPadding: 2 },
          headStyles: { fillColor: [240, 248, 255], textColor: [0, 0, 80] },
        });
        y = doc.lastAutoTable.finalY + 6;
      });

      // === Prix global ===
      if (flightOffer.price) {
        const { total, base, currency } = flightOffer.price;
        doc.setFontSize(12);
        doc.text(
          `Prix total : ${total} ${currency} (Base : ${base} ${currency})`,
          15,
          y + 4
        );
        y += 10;
      }

      // === Compagnie validatrice ===
      if (flightOffer.validatingAirlineCodes?.length) {
        doc.text(
          `Compagnie validatrice : ${flightOffer.validatingAirlineCodes.join(", ")}`,
          15,
          y
        );
        y += 10;
      }
    }

    // === Références Amadeus ===
    if (data.data.associatedRecords?.length) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text("Références Amadeus :", 15, y);
      y += 4;

      const refs = data.data.associatedRecords.map((r, i) => [
        i + 1,
        r.reference,
        r.creationDate || "-",
        r.originSystemCode || "-",
        r.status || "HK",
      ]);

      autoTable(doc, {
        startY: y,
        head: [["#", "PNR", "Création", "Système", "Statut"]],
        body: refs,
        theme: "striped",
        headStyles: { fillColor: [0, 51, 102], textColor: 255 },
        styles: { fontSize: 9 },
      });
      y = doc.lastAutoTable.finalY + 6;
    }

    // === Pied de page ===
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(120);
      doc.text(
        `Djater Voyage — Confirmation générée automatiquement`,
        105,
        290,
        { align: "center" }
      );
      doc.text(`Page ${i} / ${pageCount}`, 190, 290, { align: "right" });
    }

    // === Sauvegarde ===
    doc.save(`confirmation_${reservation.reference}.pdf`);
    toast.success("✅ PDF de confirmation généré avec succès !");
  } catch (e) {
    console.error("Erreur impression :", e);
    toast.error("❌ Impossible de générer le PDF.");
  }
};











const AdminReservationsApp = () => {
  const [admin, setAdmin] = useState(null); // stocke les infos admin si connecté
  const [loading, setLoading] = useState(true);


  const [confirmingPayment, setConfirmingPayment] = useState(null);


  // États réservations
  const [reservations, setReservations] = useState([]);
  const [selected, setSelected] = useState(null);
  const [tracking, setTracking] = useState(null);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [page, setPage] = useState(1);

  // Vérifie si une session admin existe déjà
  useEffect(() => {
    fetch(`${API_BASE}/check_session.php`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (data.loggedIn) {
          setAdmin(data.admin);
          loadReservations();
        }
      })
      .finally(() => setLoading(false));
  }, []);



function cleanFlightOffers(flightOffers) {
  return flightOffers.map(offer => {
    // On extrait uniquement les champs valides attendus par Amadeus
    const {
      type,
      id,
      source,
      instantTicketingRequired,
      nonHomogeneous,
      oneWay,
      lastTicketingDate,
      lastTicketingDateTime,
      numberOfBookableSeats,
      itineraries,
      price,
      pricingOptions,
      validatingAirlineCodes,
      travelerPricings
    } = offer;

    return {
      type,
      id,
      source,
      instantTicketingRequired,
      nonHomogeneous,
      oneWay,
      lastTicketingDate,
      lastTicketingDateTime,
      numberOfBookableSeats,
      itineraries,
      price,
      pricingOptions,
      validatingAirlineCodes,
      travelerPricings
    };
  });
}






  const confirmWithAmadeus = async (reservation) => {
    try {
      // 🔹 S'assurer que les champs sont bien parsés
      const flightOffers = typeof reservation.flight_data === "string"
        ? JSON.parse(reservation.flight_data)
        : reservation.flight_data;

      const travelers = typeof reservation.passenger_data === "string"
        ? JSON.parse(reservation.passenger_data)
        : reservation.passenger_data;

      console.log("➡️ Données envoyées pour Amadeus :", { reference: reservation.reference, flightOffers, travelers });

      const response = await fetch(`${API_BASE}/confirmation_vol.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            reference: reservation.reference,
            flightOffers: cleanFlightOffers(flightOffers),
            travelers
          }
        }),
      });

      const result = await response.json();
      console.log("✅ Réponse Amadeus :", result);

      if (result.success) {
        toast.success("✅ Réservation confirmée sur Amadeus !");
      } else {
        toast.error(result.message || "❌ Échec confirmation Amadeus");
      }
    } catch (error) {
      console.error("⚠️ Erreur confirmWithAmadeus:", error);
      toast.error("❌ Erreur de connexion au serveur");
    }
  };



  // 🔹 Mettre à jour le paiement
  const markAsPaid = async (id) => {
    try {
      const res = await fetch(`${API_BASE}/api.php`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          id,
          payment_status: "success"
        }),
      });
      const data = await res.json();
      if (data.success) {
        setReservations((prev) =>
          prev.map((r) =>
            r.id === id ? { ...r, payment_status: "success" } : r
          )
        );
        toast.success("✅ Paiement marqué comme effectué !");
      } else {
        toast.error(data.message || "Erreur lors de la mise à jour du paiement");
      }
    } catch {
      toast.error("❌ Impossible de mettre à jour le paiement");
    }
  };





  // 🔹 Charger les réservations
  const loadReservations = () => {
    fetch(`${API_BASE}/api.php`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setReservations(data.data);
        else toast.error(data.message || "Erreur lors du chargement");
      })
      .catch(() => toast.error("Impossible de charger les réservations"));
  };

  // 🔹 Connexion admin
  const login = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const res = await fetch(`${API_BASE}/login_admin.php`, {
      method: "POST",
      body: form,
      credentials: "include",
    });
    const data = await res.json();
    if (data.success) {
      setAdmin(data.admin);
      toast.success("Connexion réussie ✅");
      loadReservations();
    } else {
      toast.error(data.message || "Échec de la connexion");
    }
  };

  // 🔹 Déconnexion
  const logout = async () => {
    await fetch(`${API_BASE}/logout_admin.php`, {
      method: "POST",
      credentials: "include",
    });
    setAdmin(null);
    setReservations([]);
    toast.success("Déconnecté");
  };

  // 🔹 Gestion des détails
  const openDetails = (reservation) => {
    try {
      reservation.passenger_data = JSON.parse(reservation.passenger_data);
      reservation.flight_data = JSON.parse(reservation.flight_data);
    } catch (e) {
      console.error("Erreur parsing JSON :", e);
    }
    setSelected(reservation);
  };
  const closeDetails = () => setSelected(null);

  // 🔹 Suivi
  const openTracking = (reservation) => setTracking(reservation);
  const closeTracking = () => setTracking(null);

  const steps = ["en_attente", "en_cours", "confirmée", "terminée"];

  // 🔹 Mise à jour statut
  const updateStatus = async (id, newStatus) => {
    try {
      const res = await fetch(`${API_BASE}/api.php`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ id, reservation_status: newStatus }),
      });
      const data = await res.json();
      if (data.success) {
        setReservations((prev) =>
          prev.map((r) =>
            r.id === id ? { ...r, reservation_status: newStatus } : r
          )
        );
        if (tracking && tracking.id === id) {
          setTracking({ ...tracking, reservation_status: newStatus });
        }
        toast.success("✅ Statut mis à jour !");
      } else {
        toast.error(data.message || "Erreur lors de la mise à jour");
      }
    } catch {
      toast.error("❌ Impossible de mettre à jour le statut");
    }
  };

  // 🔹 Filtrage et recherche
  const filteredReservations = useMemo(() => {
    let filtered = reservations;
    if (search)
      filtered = filtered.filter(
        (r) =>
          r.reference?.toLowerCase().includes(search.toLowerCase()) ||
          r.customer_email?.toLowerCase().includes(search.toLowerCase()) ||
          r.customer_phone?.toLowerCase().includes(search.toLowerCase())
      );
    if (statusFilter)
      filtered = filtered.filter((r) => r.reservation_status === statusFilter);
    return filtered;
  }, [reservations, search, statusFilter]);

  // 🔹 Pagination
  const totalPages = Math.ceil(filteredReservations.length / PAGE_SIZE);
  const paginatedReservations = filteredReservations.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  const Pagination = () => (
    <div className="flex justify-center items-center gap-2 mt-4">
      <button
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300"
        disabled={page === 1}
        onClick={() => setPage((p) => Math.max(1, p - 1))}
      >
        ◀
      </button>
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i}
          className={`px-3 py-1 rounded ${page === i + 1
            ? "bg-blue-500 text-white"
            : "bg-gray-100 hover:bg-gray-200"
            }`}
          onClick={() => setPage(i + 1)}
        >
          {i + 1}
        </button>
      ))}
      <button
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300"
        disabled={page === totalPages}
        onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
      >
        ▶
      </button>
    </div>
  );

  // ⏳ Loading initial
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Chargement...</p>
      </div>
    );
  }

  // 🔒 Si pas connecté → Formulaire login
  if (!admin) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <Toaster />
        <form
          onSubmit={login}
          className="bg-white p-8 rounded-xl shadow-lg w-96"
        >
          <h2 className="text-2xl font-bold mb-6 text-center text-blue-700">
            🔑 Connexion Admin
          </h2>
          <input
            type="text"
            name="username"
            placeholder="Nom d'utilisateur"
            className="border w-full mb-4 px-4 py-2 rounded"
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Mot de passe"
            className="border w-full mb-4 px-4 py-2 rounded"
            required
          />
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded"
          >
            Se connecter
          </button>
        </form>
      </div>
    );
  }

  // ✅ Vue admin
  return (
    <div className="p-6 bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen">
      <Toaster position="top-right" />
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-extrabold text-blue-700 flex items-center gap-2">
          <span>📋</span> Gestion des Réservations
        </h1>
        <button
          onClick={logout}
          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded shadow"
        >
          🚪 Déconnexion
        </button>
      </div>

      {/* Barre de recherche et filtres */}
      <div className="flex flex-wrap gap-4 mb-6 items-center">
        <input
          type="text"
          placeholder="🔍 Rechercher par référence, email ou téléphone..."
          className="border rounded px-4 py-2 w-64 shadow"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
        <select
          className="border rounded px-4 py-2 shadow"
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setPage(1);
          }}
        >
          <option value="">Tous les statuts</option>
          {steps.map((s) => (
            <option key={s} value={s}>
              {STATUS_LABELS[s]}
            </option>
          ))}
        </select>
        <span className="ml-auto text-gray-500">
          {filteredReservations.length} réservation(s) trouvée(s)
        </span>
      </div>

      {/* Tableau moderne */}
      <div className="overflow-x-auto rounded shadow-lg bg-white">
        <table className="min-w-full">
          <thead className="bg-blue-100">
            <tr>
              <th className="p-3 text-left">Référence</th>
              <th className="p-3 text-left">Paiement</th>
              <th className="p-3 text-left">Client</th>
              <th className="p-3 text-left">Statut</th>
              <th className="p-3 text-left">Créée le</th>
              <th className="p-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedReservations.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-8 text-gray-400">
                  Aucune réservation trouvée.
                </td>
              </tr>
            ) : (
              paginatedReservations.map((r) => (
                <tr
                  key={r.id}
                  className="border-b hover:bg-blue-50 transition duration-100"
                >
                  <td className="p-3 font-mono">{r.reference}</td>
                  <td className="p-3">
                    <span className="font-bold">
                      {r.payment_amount} {r.payment_currency}
                    </span>
                    <br />
                    <span
                      className={`px-2 py-1 text-xs rounded font-semibold ${r.payment_status === "success"
                        ? "bg-green-200 text-green-700"
                        : "bg-red-200 text-red-700"
                        }`}
                    >
                      {r.payment_status}
                    </span>
                  </td>
                  <td className="p-3">
                    <span className="font-semibold">{r.customer_email}</span>
                    <br />
                    <span className="text-gray-500">📞 {r.customer_phone}</span>
                  </td>
                  <td className="p-3">
                    <select
                      value={r.reservation_status}
                      onChange={(e) => updateStatus(r.id, e.target.value)}
                      className="border rounded px-2 py-1 bg-white shadow"
                    >
                      {steps.map((s) => (
                        <option key={s} value={s}>
                          {STATUS_LABELS[s]}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="p-3">{r.created_at}</td>
                  <td className="p-3 text-center flex gap-2 justify-center">
                    <button
                      onClick={() => openDetails(r)}
                      className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded shadow"
                      title="Voir détails"
                    >
                      👁️
                    </button>
                    <button
                      onClick={() => openTracking(r)}
                      className="bg-purple-500 hover:bg-purple-600 text-white px-3 py-1 rounded shadow"
                      title="Suivre"
                    >
                      🧭
                    </button>

                    <button
                      onClick={() => setConfirmingPayment(r)}
                      className={`px-3 py-1 rounded shadow ${r.payment_status === "success"
                        ? "bg-green-300 text-green-800 cursor-not-allowed"
                        : "bg-green-500 hover:bg-green-600 text-white"
                        }`}
                      disabled={r.payment_status === "success"}
                      title="Marquer comme payé"
                    >
                      💳
                    </button>




                    {/* ✅ Affichage conditionnel */}
                    {r.reservation_status === "en_attente" && (
                      <button
                        onClick={() => confirmWithAmadeus(r)}
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow"
                      >
                        ✅ Confirmer avec Amadeus
                      </button>
                    )}

                    {r.reservation_status === "confirmée" && (
                      <button
                        onClick={() => printReservation(r)}
                        className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded shadow"
                      >
                        🖨️ Imprimer la réservation
                      </button>

                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination />

      {/* Modals */}
      {selected && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white w-full max-w-3xl p-8 rounded-xl shadow-2xl max-h-[90vh] overflow-y-auto relative">
            <button
              onClick={closeDetails}
              className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full shadow hover:bg-red-600"
              title="Fermer"
            >
              ✖
            </button>
            <h2 className="text-2xl font-bold mb-6 text-blue-700">
              ✈️ Détails Réservation{" "}
              <span className="font-mono">{selected.reference}</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold mb-2 text-lg">👤 Passager(s)</h3>
                {selected.passenger_data?.map((p, idx) => (
                  <div key={idx} className="border p-3 mb-2 rounded bg-gray-50">
                    <p className="text-lg font-bold">
                      {p.name?.firstName} {p.name?.lastName}{" "}
                      <span className="text-sm text-gray-600">
                        ({p.travelerType} - {p.gender})
                      </span>
                    </p>

                    {/* Civilité si enregistrée */}
                    {p.civility && <p>🧑 Civilité : {p.civility}</p>}

                    <p>📅 Naissance : {p.dateOfBirth}</p>

                    {/* Coordonnées si dispo */}
                    {p.contact?.emailAddress && <p>📧 Email : {p.contact.emailAddress}</p>}
                    {p.contact?.phones?.[0] && (
                      <p>
                        📞 Téléphone : +{p.contact.phones[0].countryCallingCode}{" "}
                        {p.contact.phones[0].number}
                      </p>
                    )}

                    {/* Document */}
                    {p.documents?.[0] && (
                      <div className="mt-2 border-t pt-2">
                        <p className="font-semibold">🪪 Document</p>
                        <p>Type : {p.documents[0].documentType}</p>
                        <p>Numéro : {p.documents[0].number}</p>
                        <p>Expiration : {p.documents[0].expiryDate}</p>
                        <p>Pays émetteur : {p.documents[0].issuanceCountry}</p>
                        <p>Nationalité : {p.documents[0].nationality}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div>
                <h3 className="font-semibold mb-2 text-lg">🛫 Détails du vol</h3>
                {selected.flight_data?.map((f, idx) => (
                  <div key={idx} className="border p-3 mb-3 rounded bg-gray-50">

                    {/* --- Itinéraires --- */}
                    {f.itineraries.map((it, i) => (
                      <div key={i} className="mb-3">
                        <h4 className="font-semibold text-gray-700 mb-2">
                          Itinéraire {i + 1} • Durée totale : {it.duration}
                        </h4>
                        {it.segments.map((s, j) => (
                          <div key={j} className="mb-3 pl-2 border-l-4 border-blue-400">
                            <p>
                              <span className="font-bold">{s.departure.iataCode}</span>{" "}
                              ({new Date(s.departure.at).toLocaleString()}) ➝{" "}
                              <span className="font-bold">{s.arrival.iataCode}</span>{" "}
                              ({new Date(s.arrival.at).toLocaleString()})
                            </p>
                            <p>
                              ✈️ {s.carrierCode} {s.number} | Avion : {s.aircraft.code}
                            </p>
                            <p>
                              👤 Opéré par :{" "}
                              {s.operating?.carrierCode
                                ? s.operating.carrierCode
                                : s.carrierCode}
                            </p>
                            <p>⏱️ Durée : {s.duration}</p>
                            <p>
                              🛋️ Classe cabine :{" "}
                              {s.class ? s.class : "N/A"} •
                              Tarif : {s.fareDetailsBySegment?.[0]?.cabin || "N/A"}
                            </p>
                            <p>
                              🎒 Bagages inclus :{" "}
                              {s.fareDetailsBySegment?.[0]?.includedCheckedBags?.quantity
                                ? `${s.fareDetailsBySegment[0].includedCheckedBags.quantity} bagage(s)`
                                : "Non inclus"}
                            </p>
                            {j < it.segments.length - 1 && (
                              <p className="text-sm text-gray-500 italic">
                                ⏳ Escale à {it.segments[j + 1].departure.iataCode} avant le prochain vol
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    ))}

                    {/* --- Informations tarifaires --- */}
                    <div className="mt-2">
                      <p className="font-bold text-blue-700">
                        💰 Prix total : {f.price.total} {f.price.currency}
                      </p>
                      <p>💵 Tarif de base : {f.price.base} {f.price.currency}</p>
                      <p>🧾 Taxes : {f.price.fees?.reduce((sum, fee) => sum + parseFloat(fee.amount), 0)} {f.price.currency}</p>
                      {f.pricingOptions && (
                        <p>
                          🔄 Rebooking possible :{" "}
                          {f.pricingOptions.refundable ? "Oui (remboursable)" : "Non"} |{" "}
                          {f.pricingOptions.changeable ? "Modifiable" : "Non modifiable"}
                        </p>
                      )}
                    </div>

                    {/* --- Rebooking / Conditions tarifaires --- */}
                    {f.validatingAirlineCodes && (
                      <p className="mt-1 text-sm text-gray-600">
                        ✈️ Compagnie validatrice : {f.validatingAirlineCodes.join(", ")}
                      </p>
                    )}
                    {f.travelerPricings?.map((tp, tIdx) => (
                      <div key={tIdx} className="mt-2 text-sm text-gray-700">
                        👤 Voyageur {tIdx + 1} ({tp.travelerType}) — Tarif :{" "}
                        {tp.fareOption}
                        {tp.fareDetailsBySegment?.map((fd, fdIdx) => (
                          <div key={fdIdx}>
                            🛋️ Cabine : {fd.cabin}, Classe : {fd.class} (
                            {fd.includedCheckedBags?.quantity || 0} bagage(s) inclus)
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      )}

      {tracking && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white w-full max-w-xl p-8 rounded-xl shadow-2xl relative">
            <button
              onClick={closeTracking}
              className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full shadow hover:bg-red-600"
              title="Fermer"
            >
              ✖
            </button>
            <h2 className="text-2xl font-bold mb-6 text-purple-700">
              🔍 Suivi Réservation{" "}
              <span className="font-mono">{tracking.reference}</span>
            </h2>
            <div className="flex justify-between items-center mb-8">
              {steps.map((step, i) => {
                const activeIndex = steps.indexOf(tracking.reservation_status);
                const isActive = i <= activeIndex;
                return (
                  <div key={step} className="flex-1 text-center relative">
                    <div
                      className={`w-10 h-10 mx-auto rounded-full flex items-center justify-center font-bold text-lg ${isActive
                        ? "bg-green-500 text-white"
                        : "bg-gray-300 text-gray-500"
                        }`}
                    >
                      {i + 1}
                    </div>
                    <p
                      className={`mt-2 text-sm ${isActive
                        ? "text-green-700 font-bold"
                        : "text-gray-500"
                        }`}
                    >
                      {STATUS_LABELS[step]}
                    </p>
                    {i < steps.length - 1 && (
                      <div
                        className={`absolute top-5 left-1/2 w-full h-1 ${isActive ? "bg-green-500" : "bg-gray-300"
                          }`}
                        style={{ transform: "translateX(50%)" }}
                      ></div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}










      {confirmingPayment && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-2xl relative text-center">
            <h2 className="text-xl font-bold mb-4 text-blue-700">⚠️ Confirmation</h2>
            <p className="mb-6 text-gray-700">
              Voulez-vous vraiment marquer la réservation{" "}
              <span className="font-mono font-bold">{confirmingPayment.reference}</span>{" "}
              comme <span className="text-green-600 font-bold">payée</span> ?
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => {
                  markAsPaid(confirmingPayment.id);
                  setConfirmingPayment(null);
                }}
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded shadow"
              >
                ✅ Oui, confirmer
              </button>
              <button
                onClick={() => setConfirmingPayment(null)}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded shadow"
              >
                ❌ Annuler
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default AdminReservationsApp;
